import getConfig from 'next/config';


const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()
const {
    internalApiEndpoint,
} = serverRuntimeConfig;
const {
    apiEndpoint,
    bucketName,
    authRegion,
    authUserPoolId,
    authUserPoolWebClientId,
    authIdentityPoolID,
} = publicRuntimeConfig

// console.log({ apiEndpoint })
// console.log({ bucketName })
// console.log({ authRegion })
// console.log({ authUserPoolId })
// console.log({ authUserPoolWebClientId })
// console.log({ authIdentityPoolID })


const awsExports = {
    Storage: {
        AWSS3: {
            region: "eu-west-1",
            bucket: bucketName,
        }
    },
    // School
    Auth: {
        region: authRegion,
        userPoolId: authUserPoolId,
        userPoolWebClientId: authUserPoolWebClientId,
        identityPoolId: authIdentityPoolID,
        mandatorySignIn: false,
    },
    API: {
        endpoints: [
            {
                name: "ClientRestApi",
                endpoint: apiEndpoint,
                region: "eu-west-1"
            },
            {
                name: "InternalApi",
                endpoint: internalApiEndpoint,
                region: "eu-west-1"
            }
        ]
    }

}

export default awsExports;